<script setup></script>

<template>
    <AuthWatcher />
    <router-view />
</template>

<style scoped></style>
